module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    ref: "assetTable",
    attrs: {
      "table-ref": _vm.tableRef,
      "title": _vm.title,
      "title-heading": _vm.titleHeading,
      "icon": "fa fa-tools",
      "url": '/assets/site/' + (_vm.siteId ? _vm.siteId : '') +
        (this.ownerId ? '/owner/' + this.ownerId : '') +
        (this.filterCol && this.filterVal ? '/' + this.filterCol + '/' + this.filterVal : ''),
      "fields": _vm.fields,
      "hideTop": _vm.hideTop,
      "showTitle": _vm.showTitle,
      "showSearch": _vm.showSearch,
      "showRefresh": _vm.showRefresh,
      "options": _vm.siteData,
      "searchPlaceholder": _vm.searchPlaceholder,
      "add-action": _vm.noAdd ? null : _vm.isManager('project|maintenance|finance') ? _vm.action : null,
      "add-props": _vm.noAdd ? null : _vm.addPropsData,
      "detail-component": _vm.isTelco() ? null : 'equip-detail-row'
    },
    on: {
      "totalChanged": _vm.totalChanged
    },
    scopedSlots: _vm._u([{
      key: "shortName",
      fn: function(props) {
        return [_c('org-badge', {
          attrs: {
            "organisation": props.rowData.organisation
          }
        })]
      }
    }, {
      key: "assets",
      fn: function(props) {
        return [_c('el-row', {
          staticStyle: {
            "padding-right": "1em"
          },
          attrs: {
            "gutter": 8
          }
        }, [_c('el-col', {
          attrs: {
            "xs": 24,
            "sm": 24,
            "md": 12,
            "lg": 14
          }
        }, [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatAssetName(props.rowData))
          }
        }), _vm._v(" "), (props.rowData.diameter) ? _c('span', {
          staticClass: "text-primary"
        }, [_vm._v(" | Dia: "), _c('b', [_vm._v(_vm._s(props.rowData.diameter))]), _vm._v(" °")]) : _vm._e(), _vm._v(" "), (props.rowData.agl) ? _c('b', {
          staticClass: "text-success"
        }, [_vm._v(" | AGL: "), _c('b', [_vm._v(_vm._s(props.rowData.agl))]), _vm._v("m.")]) : _vm._e(), _vm._v(" "), (props.rowData.installedOn) ? _c('span', {
          staticClass: "text-warning"
        }, [_vm._v(" | Installed: " + _vm._s(_vm.formatDate(props.rowData.installedOn)))]) : _vm._e()]), _vm._v(" "), _c('el-col', {
          attrs: {
            "xs": 24,
            "sm": 24,
            "md": 12,
            "lg": 10,
            "align": _vm.isDesktop ? 'right' : ''
          }
        }, [(props.rowData.setNo) ? _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.addSuffix(props.rowData.setNo, true, true, 'Set'))
          }
        }, [_vm._v(" ")]) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.formatBillable(props.rowData.isBillable)) + " \n          ")])], 1)]
      }
    }])
  }), _vm._v(" "), (_vm.isTowerCo() && !_vm.readOnly && _vm.showQrCode && _vm.isManager('project|maintenance') && _vm.totals > 0) ? _c('div', {
    staticClass: "bg-primary-lighten-1",
    staticStyle: {
      "padding": "0.2em"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "round": "",
      "icon": _vm.icon,
      "disabled": !_vm.enabled
    },
    on: {
      "click": _vm.qrCodeActions
    }
  }, [_vm._v(" " + _vm._s(_vm.qrCodeBtn))])], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20b84d51"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/EquipTable.vue
// module id = 1454
// module chunks = 0